import React, {
  useRef, useEffect, useState,
} from 'react';
import {
  findDOMNode,
} from 'react-dom';
import moment from 'moment';
import classNames from 'classnames';
import Linkify from 'react-linkify';
import ReactTooltip from 'react-tooltip';
import BubbleBot from './BubbleBot';
import BubbleUser from './BubbleUser';
import BubbleEvent from './BubbleEvent';
import BubbleStaff from './BubbleText';
import BubbleNotification from './BubbleNotification';
import BubbleVoiceCall from './BubbleVoiceCall';
import BubbleVoiceCallIncoming from './BubbleVoiceCallIncoming';
import BubbleNote from './BubbleNote';
import BubbleVM from './BubbleVM';
import BubbleVC from './BubbleVC';
import Loading from '../../common/Loading';

import helpers from '../helpers';
import Logo from '../../../assets/images/truelark_icon.svg';
import send from '../../../assets/images/send.svg';

import './index.scss';
import utils from '../../../lib/utils';
import BubbleWeaveVoiceCall from './BubbleWeaveVoiceCallIncoming';

const isBotMessage = (record) => record.sender === 'BOT' || record.sender === 'WIDGET_TRIGGERED' || record.sender === 'TRAINER' || record.sender === 'TRAINER_TRIGGERED';
const twilioRegex = /(https?:\/\/.*?\.mp3)/g;
const textLimit = 500;
const filterConversation = function (filter, messages) {
  if (filter === 'FULL') {
    return messages;
  } else {
    return messages.filter(
      (message) => message.type === 'NOTE' || message.type === 'EVENT' || message.message_type === 'TRANSCRIPT' || message.justEvent,
    );
  }
};
const sortAndremoveDuplicate = (messages) => {
  const unique = [];
  messages.forEach((x) => {
    if (unique.filter((a) => a.id == x.id).length === 0) {
      unique.push(x);
    }
  });
  unique.sort((a, b) => a.timestamp - b.timestamp);
  return unique;
};
const validateAddon = function (validateAddon) { };
const getName = (StaffManagement, business, id) => {
  let user = StaffManagement.list.filter((staff) => {
    return staff.id == id;
  });
  if (user.length > 0) {
    return user[0].firstName + ' ' + user[0].lastName;
  } else if (business.clientUser.id === id) {
    return business.clientUser.firstName + ' ' + business.clientUser.lastName;
  }
  return 'Staff';
};

const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
      const elem = document.getElementById('messageContiner');
      let pageBottom = document.querySelector('#page-bottom');
      if (elem) {
        elem.style.scrollBehavior = 'inherit';
        elem.scrollTop = elem.scrollHeight;
        elem.style.scrollBehavior = 'smooth';
      }
    }
  }, deps);
};
const getEventType = (eventsubtype, text) => {
  if (eventsubtype === 'BUSINESS_ACTION_AUTO_CHAT_STATUS') {
    if (text.includes('ACTIVE')) {
      return 'ACTIVE';
    } else {
      return 'PAUSED';
    }
  } else if (eventsubtype === 'BUSINESS_ACTION_STATUS') {
    if (text.includes('FOLLOWUP_NEEDED')) {
      return 'NEEDS_ATTENTION';
    } else {
      return 'RESOLVED';
    }
  } else if (
    eventsubtype === 'BUSINESS_ACTION_CONVERSATION_ASSIGNMENT_STATUS'
  ) {
    return 'ASSIGNMENT';
  } else if (eventsubtype === 'USER_UNSUBSCRIBED') {
    return 'OPT_OUT';
  } else {
    return eventsubtype;
  }
};

const getEventName = (eventsubtype, text) => {
  if (eventsubtype === 'BUSINESS_ACTION_AUTO_CHAT_STATUS') {
    if (text.includes('ACTIVE')) {
      return 'Auto-response activated';
    } else {
      return 'Auto-response paused';
    }
  } else if (eventsubtype === 'BUSINESS_ACTION_STATUS') {
    if (text.includes('FOLLOWUP_NEEDED')) {
      return 'Needs Attention';
    } else {
      return 'Marked as resolved';
    }
  } else if (
    eventsubtype === 'BUSINESS_ACTION_CONVERSATION_ASSIGNMENT_STATUS'
  ) {
    return text;
  } else if (eventsubtype === 'USER_UNSUBSCRIBED') {
    return 'Customer opted out';
  } else {
    return text;
  }
};

const sanitizeEventText = (eventText) => {
  if (eventText.includes('FOLLOWUP_NEEDED')) {
    const nameSplit = eventText.split(':');
    if (nameSplit.length > 1) {
      return 'set by' + nameSplit[1];
    } else {
      return 'set by Staff';
    }
  } else {
    return eventText;
  }
};
const extractName = (inputString) => {
  try {
    const match = inputString.match(/By:\s*(.*)/);
    if (match) {
      const name = match[1].trim();
      return name || 'Staff'; // Return the name or an empty string if name is not provided
    } else {
      return 'Staff'; // Return empty string if "By:" pattern isn't found
    }
  } catch (error) {
    return 'Staff'; // Return empty string in case of any errors
  }
};

const getChatDisableMessage = (
  tags,
  auto_chat_status,
  dropdownType,
  addOnNotEnabled,
) => {
  if (addOnNotEnabled) {
    return 'Get the Business Messenger add-on <br/> to reply to conversations, start new <br/> ones, and more!';
  } else if (tags.includes('IS_LANDLINE')) {
    return 'Unfortunately the guest called <br/>from a landline and you won’t be able to <br/> text them';
  } else if (dropdownType !== 1) {
    return 'Assign conversation to yourself to send a message';
  } else {
    return 'Get the Business Messenger add-on <br/> to reply to conversations, start new <br/> ones, and more!';
  }
};
const getToolTipPosition = () => {
  if (window.innerWidth < 768) {
    return 'right';
  } else {
    return 'top';
  }
};
const Transcript = ({
  getConversationTranscripts,
  businessId,
  selectedConversation,
  isLoading,
  createNewConversation,
  filter,
  addOnNotEnabled,
  addNotes,
  StaffManagement,
  business,
  conversations,
  auto_chat_status,
  dropdownType,
  selectedContact,
  showError,
}) => {
  const scrollToContainer = useRef(null);
  const bottomRef = useRef(null);
  const noficationRef = useRef(null);
  const inputRef = useRef(null);
  let activeText =
    !addOnNotEnabled && dropdownType && dropdownType === 1 ? 'CHAT' : 'NOTE';
  activeText = createNewConversation
    ? utils.isEmptyObject(selectedContact)
      ? null
      : activeText
    : activeText;

  console.log('conversations 123--->', showError);
  const [textType, setTextType] = useState(activeText);
  const [text, setText] = useState('');
  const [showNotification, notificationToggle] = useState(null);
  const {
    details,
    notes,
    otherconversation,
    workflow_task,
    tags,
    lastMessageTime,
    newlyCreated,
    userName,
    userPhone,
    status,
    initiatedFor
  } = selectedConversation;
  const { messages, notifications, events, voice_calls} = details || {};
  console.log('voice_calls', voice_calls);
  const placeHolder =
    textType === 'CHAT' || textType === 'NOTE'
      ? textType === 'CHAT'
        ? 'Type a message'
        : 'Type a note'
      : '';
  const setNotificationView = (id) => {
    if (id === showNotification) {
      notificationToggle(null);
    } else {
      notificationToggle(id);
      setTimeout(() => {
        noficationRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      });
    }
  };
  const allNotes = { conversation_notes: notes.conversation_notes || [] };
  for (let i = 0; i < otherconversation.length; i++) {
    allNotes.conversation_notes = allNotes.conversation_notes.concat(
      otherconversation[i].notes.conversation_notes,
    );
  }

  let notesstructure = allNotes.conversation_notes.map((note) => ({
    sender: 'BUSINESS',
    id: note.added_by + note.updated_time,
    timestamp: moment
      .utc(note.updated_time + '.000Z')
      .local()
      .valueOf(),
    userName: getName(StaffManagement, business, note.added_by),
    type: 'NOTE',
    message: note.text,
  }));

  let notifications_list = [];
  if (notifications) {
    notifications_list = notifications.map((notification) => ({
      sender: 'BUSINESS',
      id: notification.id,
      timestamp: notification.timestamp,
      userName: getName(StaffManagement, business, notification.trainerId),
      type: 'EVENT',
      subType: 'NOTIFICATION',
      message: notification.subject,
      data: {
        eventName: 'Needs Attention',
        event: 'NEEDS_ATTENTION',
        eventDescription: notification.subject,
        eventBody: notification.display_text,
        category: notification?.category,
        nonNotification: false,
      },
    }));
  }
  let events_list = [];
  const showing_event = [
    'BUSINESS_ACTION_STATUS',
    'BUSINESS_ACTION_AUTO_CHAT_STATUS',
    'BUSINESS_ACTION_CONVERSATION_ASSIGNMENT_STATUS',
    'USER_UNSUBSCRIBED',
  ];
  if (events) {
    events_list = events
      .filter((event) => showing_event.includes(event.subType))
      .map((event) => ({
        sender: 'BUSINESS',
        id: event.id,
        timestamp: event.timestamp,
        userName: getName(StaffManagement, business, event.trainerId),
        type: 'EVENT',
        message: event.text,
        data: {
          eventName: getEventName(event.subType, event.text),
          event: getEventType(event.subType, event.text),
          eventDescription: sanitizeEventText(event.text),
          eventCreatedby: extractName(event.text),
          nonNotification: true,
        },
      }));
  }
  let voice_calls_list = [];
  if (voice_calls) {
    voice_calls_list = voice_calls.map((voice_call) => ({
      sender: 'BUSINESS',
      initiatedFor: voice_call.initiatedFor || initiatedFor,
      id: voice_call.id,
      timestamp: voice_call.timestamp,
      userName: 'VOICE BOT',
      type: 'VOICE_CALL',
      voiceCalls: true,
      justEvent: false,
      subType: 'VOICE_CALL',
      message: voice_call?.url,
      status: voice_call?.status,
      data: {
        eventName: 'Needs Attention',
        event: 'NEEDS_ATTENTION',
        eventDescription: voice_call.url,
        eventBody: voice_call.url,
        category: voice_call?.category,
        callerName: voice_call?.callerName,
        callerNumber: voice_call?.callerNumber,
        nonNotification: false,
        summary: voice_call?.summary,
        initiatedFor: voice_call.initiatedFor || initiatedFor,
        auto_transcript: voice_call?.auto_transcript,
        userName,
        userPhone,
        tags: voice_call?.tags,
      },
    }));
  }

  notesstructure = notesstructure
    ? notesstructure.concat(notifications_list)
    : notesstructure;
  notesstructure = notesstructure
    ? notesstructure.concat(events_list)
    : notesstructure;
  notesstructure = notesstructure
    ? notesstructure.concat(voice_calls_list)
    : notesstructure;
  let combinedmessage = messages
    ? messages.concat(notesstructure)
    : notesstructure;

  for (let i = 0; i < combinedmessage.length; i++) {
    if (combinedmessage[i]?.message?.match(twilioRegex)) {
      combinedmessage[i].voiceMails = true;
      combinedmessage[i].justEvent = false;
      combinedmessage[i].vmLink = combinedmessage[i].message.match(
        twilioRegex,
      )[0];
    }
  }
  console.log('voice_calls 1', voice_calls_list, combinedmessage);
  if (selectedConversation.initiatedFor === 'MISSED_CALL') {
    combinedmessage.push({
      sender: 'USER',
      id: selectedConversation.id,
      timestamp: selectedConversation.startTime,
      userName: 'Staff',
      message: '',
      voiceMails: true,
      justEvent: true,
    });
  }
  combinedmessage = sortAndremoveDuplicate(combinedmessage);
  console.log('selectedConversation', newlyCreated, combinedmessage);
  useEffect(() => {
    setText('');
    let activeText =
      !addOnNotEnabled && dropdownType && dropdownType === 1 ? 'CHAT' : 'NOTE';
    activeText = createNewConversation
      ? utils.isEmptyObject(selectedContact)
        ? null
        : activeText
      : activeText;
    if (activeText === 'CHAT') {
      inputRef.current.focus();
    } else {
      inputRef.current.blur();
    }
  }, [selectedConversation.id]);

  useEffect(() => {
    if (conversations.postClinetNotes) {
      setText('');
    }
  }, [conversations.postClinetNotes]);

  useEffect(() => {
    let activeText =
      !addOnNotEnabled && dropdownType && dropdownType === 1 ? 'CHAT' : 'NOTE';
    activeText = createNewConversation
      ? utils.isEmptyObject(selectedContact)
        ? null
        : activeText
      : activeText;
    if (activeText === 'CHAT') {
      inputRef.current.focus();
    } else {
      inputRef.current.blur();
    }
    setTextType(activeText);
  }, [auto_chat_status, dropdownType, selectedContact]);

  useDidMountEffect(() => {
    if (bottomRef && bottomRef.current) {
      findDOMNode(bottomRef.current).scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }, [combinedmessage.length]);

  const onEnterPress = (e) => {
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      addNotes(text, textType);
    }
  };
  if (isLoading) {
    return (
      <div className="transcript__messages--blank-state">
        <div className="transcript__messages__blank-container">
          <Loading />
        </div>
      </div>
    );
  }

  if (
    (!combinedmessage && !newlyCreated) ||
    (!combinedmessage.length && !newlyCreated)
  ) {
    return (
      <div className="transcript">
        <div className="transcript__messages--blank-state">
          <div className="transcript__messages__blank-container">
            {!showError ?
              (<>
                <i className="material-icons">content_copy</i>
                <p className="transcript__messages__blank-container__title">
                  No conversation transcript available
                </p>
              </>) : (
                <p className="transcript__messages__blank-container__error-message">
                  Something went wrong. please try again later
                </p>
              )}
          </div>
        </div>
        {selectedConversation &&
          selectedConversation.textType &&
          selectedConversation.textType === 'WEBCHAT' &&
          lastMessageTime &&
          moment().diff(moment(lastMessageTime), 'minutes') > 10 ? (
            <div className="webchat-idle">
              Webchat is idle for more than 10 min
            </div>
        ) : null}
        <div
          className={classNames('send-message-container', {
            'disable-click':
              createNewConversation && utils.isEmptyObject(selectedContact),
          })}
        >
          <ReactTooltip />
          <div className="send-message-container_input">
            <textarea
              type="text"
              placeholder={placeHolder}
              ref={inputRef}
              value={text}
              onKeyDown={onEnterPress}
              onFocus={() => validateAddon(addOnNotEnabled)}
              onChange={(e) => {
                if (e.target.value.length < 501) {
                  setText(e.target.value);
                }
              }}
            />
          </div>
          <div className="send-message-container_actions">
            <div className="message-type">
              {!addOnNotEnabled &&
                dropdownType &&
                dropdownType === 1 &&
                !tags.includes('IS_LANDLINE') ? (
                <div
                  onClick={() => setTextType('CHAT')}
                  className={classNames('type-of-message', {
                    active: textType === 'CHAT',
                  })}
                >
                  Chat
                </div>
              ) : (
                <div
                  data-class="my-tooltip"
                  data-multiline
                  data-tip-disable={false}
                  data-place={getToolTipPosition()}
                  data-tip={getChatDisableMessage(
                    tags,
                    auto_chat_status,
                    dropdownType,
                    addOnNotEnabled,
                  )}
                  className={classNames('type-of-message', {
                    active: textType === 'CHAT',
                  })}
                >
                  Chat
                </div>
              )}
              {selectedConversation.staffCreated ? (
                <div className="disabled-type-of-message">Note</div>
              ) : (
                <div
                  onClick={() => setTextType('NOTE')}
                  className={classNames('type-of-message', {
                    'active-note': textType === 'NOTE',
                  })}
                >
                  Note
                </div>
              )}
            </div>
            {!(
              createNewConversation && utils.isEmptyObject(selectedContact)
            ) && (
                <div className="message-send">
                  {textType === 'NOTE' && (
                    <div className="notes-description">
                      <i className="material-icons">visibility</i> Notes are
                      visible only to your team
                    </div>
                  )}
                  <div
                    className={classNames('char-count', {
                      limit: text.length == textLimit,
                    })}
                  >
                    {text.length}/{textLimit}
                  </div>
                  {conversations.postClinetNotes !== true && (
                    <div
                      className={classNames('send', {
                        post: textType === 'NOTE',
                      })}
                      onClick={() => addNotes(text, textType)}
                    >
                      {textType === 'CHAT' ? (
                        <img width="15px" height="16px" src={send} />
                      ) : (
                        'Add note'
                      )}
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
        <div
          className={classNames('error-message', {
            'hide-message': auto_chat_status !== 'PAUSED' && !addOnNotEnabled,
          })}
        >
          <span>{workflow_task}</span>
        </div>
      </div>
    );
  }
  const contactName = userName?.trim()
    ? userName.trim()
    : utils.formatPhoneNumber(userPhone);
  console.log('voice_calls 2', combinedmessage);
  return (
    <div className="transcript">
      <div
        id="messageContiner"
        className={classNames('transcript__messages', {
          'ios-chrome':
            /CriOS/i.test(navigator.userAgent) &&
            /iphone|ipod|ipad/i.test(navigator.userAgent),
        })}
      >
        {newlyCreated && !utils.isEmptyObject(selectedContact) && (
          <div className="new-conversation">
            This is the beginning of your conversation history with{' '}
            {contactName}. You can transfer this conversation back to TrueLark
            Auto-response at any time.
          </div>
        )}
        {filterConversation(filter, combinedmessage).map((record, index) => {
          const dom = [];
          const prevRecord = combinedmessage[index - 1] || {};
          const nextRecord = combinedmessage[index + 1] || {};
          const prevDateString = moment(prevRecord.timestamp).format(
            'Do MMM, YYYY',
          );
          const prevMessageTimeDiff = moment(record.timestamp).diff(
            moment(prevRecord.timestamp),
            'minutes',
          );
          const dateString = moment(record.timestamp).format('Do MMM, YYYY');
          const message = (
            <Linkify properties={{ target: '_blank' }}>
              {record.message}
            </Linkify>
          );

          if (prevDateString !== dateString) {
            dom.push(
              <div
                className="transcript__messages__separator"
                key={`time-${record.id}`}
              >
                <div className="dashed-divider" />
                <div className="transcript__messages__separator__name">
                  {helpers.abbrivateDate(record.timestamp)}
                </div>
                <div className="dashed-divider" />
              </div>,
            );
          }

          if (isBotMessage(record)) {
            dom.push(
              <div className="transcript__messages__bot" key={record.id}>
                {!isBotMessage(prevRecord) || prevMessageTimeDiff > 0 ? (
                  <div className="transcript__messages__bot__name">
                    <div className="transcript__messages__bot__name__header">
                      <div className="time">
                        {moment(record.timestamp).format('hh:mm A')}
                      </div>
                      <div className="seperator" />
                      <div className="name">
                        <img src={Logo} />
                        TrueLark
                      </div>
                    </div>
                  </div>
                ) : null}
                <BubbleBot message={message} />
              </div>,
            );
          } else if (record.sender === 'USER') {
            const name = record?.userName?.trim()
              ? record.userName.trim()
              : utils.formatPhoneNumber(record.userPhone);
            dom.push(
              <div className="transcript__messages__user" key={record.id}>
                {prevRecord.sender !== 'USER' ||
                  record.voiceMails ||
                  prevRecord.justEvent ||
                  prevMessageTimeDiff > 0 ? (
                  <div className="transcript__messages__user__name">
                    <div className="transcript__messages__user__name__header">
                      <div className="time">
                        {moment(record.timestamp).format('hh:mm A')}
                      </div>
                      <div className="seperator" />
                      {record.voiceMails ? (
                        <div className="vm-descripion">
                          <div>
                            <span>
                              {!record.justEvent
                                ? 'Missed call:'
                                : 'Missed call'}
                            </span>
                            {record.message}
                          </div>
                        </div>
                      ) : (
                        <div className="name">{name}</div>
                      )}
                    </div>
                  </div>
                ) : null}
                {record.voiceMails ? (
                  !record.justEvent ? (
                    <BubbleVM message={record.vmLink} />
                  ) : null
                ) : !record.justEvent ? (
                  <BubbleUser message={message} />
                ) : null}
              </div>,
            );
          } else if (record.sender === 'STAFF') {
            dom.push(
              <div className="transcript__messages__staff" key={record.id}>
                {!(
                  prevRecord.sender === 'STAFF' &&
                  prevRecord.trainerId === record.trainerId
                ) || prevMessageTimeDiff > 0 ? (
                  <div className="transcript__messages__staff__name">
                    <div className="transcript__messages__staff__name__header">
                      <div className="time">
                        {moment(record.timestamp).format('hh:mm A')}
                      </div>
                      <div className="seperator" />
                      <div className="name">
                        {getName(StaffManagement, business, record.trainerId)}
                      </div>
                    </div>
                  </div>
                ) : null}
                <BubbleStaff message={message} />
              </div>,
            );
          } else if (record.sender === 'BUSINESS') {
            if (record.type == 'EVENT') {
              dom.push(
                <>
                  <div className="transcript__messages__event" key={record.id}>
                    <div className="transcript__messages__event__name">
                      <div className="transcript__messages__event__name__header">
                        <div className="time">
                          {moment(record.timestamp).format('hh:mm A')}
                        </div>
                        <div className="seperator" />
                      </div>
                    </div>
                    <BubbleEvent
                      data={record.data}
                      record={record}
                      eventCreatedby={record.userName}
                    />
                    {/* //showNotification, setNotificationView */}
                    {record.subType === 'NOTIFICATION' && (
                      <div
                        className="hide-detaials-button"
                        onClick={() => setNotificationView(record.id)}
                      >
                        {showNotification === record.id ? 'hide' : 'show'}{' '}
                        details
                      </div>
                    )}
                  </div>
                  {record.subType === 'NOTIFICATION' && (
                    <>
                      <BubbleNotification
                        message={record.data.eventBody}
                        showNotification={showNotification}
                        id={record.id}
                      />
                      {record.id === showNotification && (
                        <div ref={noficationRef} />
                      )}
                    </>
                  )}
                </>,
              );
            } else if (record.type == 'VOICE_CALL') {
              dom.push(
                <>
                  <div className="transcript__messages__event" key={record.id}>
                    <div className="transcript__messages__event__name">
                      <div className="transcript__messages__event__name__header">
                        <div className="time">
                          {moment(record.timestamp).format('hh:mm A')}
                        </div>
                        <div className="seperator" />
                      </div>
                    </div>
                    <BubbleVC
                      data={record.data}
                      record={record}
                      message={record.message}
                      eventCreatedby={record.userName}
                    />
                    {/* //showNotification, setNotificationView */}
                  </div>
                  {record.subType === 'VOICE_CALL' && record.initiatedFor !== 'INCOMING_VOICE_CALL' && record?.status === 'FINISHED' && (
                    record.initiatedFor === 'VOICE_CALL' ? (
                      <BubbleVoiceCallIncoming
                        URL={record.message}
                        data={record.data}
                        selectedConversation={selectedConversation}
                      />
                    ) : (
                      <BubbleVoiceCall
                        URL={record.message}
                        data={record.data}
                        selectedConversation={selectedConversation}
                      />
                    )
                  )}
                  {record.subType === 'VOICE_CALL' && record.initiatedFor === 'INCOMING_VOICE_CALL' && 
                      <BubbleWeaveVoiceCall
                        URL={record.message}
                        data={record.data}
                        selectedConversation={selectedConversation}
                      />
                  }
                </>,
              );
            } else if (record.type == 'TEXT') {
              dom.push(
                <div className="transcript__messages__staff" key={record.id}>
                  <div className="transcript__messages__staff__name">
                    <div className="transcript__messages__staff__name__header">
                      <div className="time">
                        {moment(record.timestamp).format('hh:mm A')}
                      </div>
                      <div className="seperator" />
                      <div className="name">{record.userName}</div>
                    </div>
                  </div>
                  <BubbleStaff message={message} />
                </div>,
              );
            } else if (record.type == 'NOTE') {
              dom.push(
                <div className="transcript__messages__note" key={record.id}>
                  <div className="transcript__messages__note__name">
                    <div className="transcript__messages__note__name__header">
                      <div className="time">
                        {moment(record.timestamp).format('hh:mm A')}
                      </div>
                      <div className="seperator" />
                      <div className="name">{record.userName} left a note:</div>
                    </div>
                  </div>
                  <BubbleNote message={message} />
                </div>,
              );
            }
          }
          return dom;
        })}
        <div id="page-bottom" ref={bottomRef} style={{ paddingBottom: 10 }} />
      </div>
      {/* Always scroll to this container */}
      {/* <div ref={scrollToContainer} /> */}
      <div>
        {selectedConversation &&
          selectedConversation.textType &&
          selectedConversation.textType === 'WEBCHAT' &&
          lastMessageTime &&
          moment().diff(moment(lastMessageTime), 'minutes') > 10 ? (
          <div className="webchat-idle">
            Webchat is idle for more than 10 min
          </div>
        ) : null}
        <div
          className={classNames('send-message-container', {
            'disable-click':
              createNewConversation && utils.isEmptyObject(selectedContact),
          })}
        >
          <ReactTooltip />
          <div className="send-message-container_input">
            <textarea
              type="text"
              placeholder={placeHolder}
              ref={inputRef}
              value={text}
              onKeyDown={onEnterPress}
              onFocus={() => validateAddon(addOnNotEnabled)}
              onChange={(e) => {
                if (e.target.value.length < 501) {
                  setText(e.target.value);
                }
              }}
            />
          </div>
          <div className="send-message-container_actions">
            <div className="message-type">
              {!addOnNotEnabled &&
                dropdownType &&
                dropdownType === 1 &&
                !tags.includes('IS_LANDLINE') ? (
                <div
                  onClick={() => setTextType('CHAT')}
                  className={classNames('type-of-message', {
                    active: textType === 'CHAT',
                  })}
                >
                  Chat
                </div>
              ) : (
                <div
                  data-class="my-tooltip"
                  data-multiline
                  data-tip-disable={false}
                  data-place={getToolTipPosition()}
                  data-tip={getChatDisableMessage(
                    tags,
                    auto_chat_status,
                    dropdownType,
                    addOnNotEnabled,
                  )}
                  className="type-of-message chat-disabled"
                >
                  Chat
                </div>
              )}
              {selectedConversation.staffCreated ? (
                <div className="disabled-type-of-message">Note</div>
              ) : (
                <div
                  onClick={() => setTextType('NOTE')}
                  className={classNames('type-of-message', {
                    'active-note': textType === 'NOTE',
                  })}
                >
                  Note
                </div>
              )}
            </div>
            {!(
              createNewConversation && utils.isEmptyObject(selectedContact)
            ) && (
                <div className="message-send">
                  {textType === 'NOTE' && (
                    <div className="notes-description">
                      <i className="material-icons">visibility</i> Notes are
                      visible only to your team
                    </div>
                  )}
                  <div
                    className={classNames('char-count', {
                      limit: text.length == textLimit,
                    })}
                  >
                    {text.length}/{textLimit}
                  </div>
                  {conversations.postClinetNotes !== true && (
                    <div
                      className={classNames('send', {
                        post: textType === 'NOTE',
                      })}
                      onClick={() => addNotes(text, textType)}
                    >
                      {textType === 'CHAT' ? (
                        <img width="15px" height="16px" src={send} />
                      ) : (
                        'Add note'
                      )}
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
        <div
          className={classNames('error-message', {
            'hide-message': auto_chat_status === 'PAUSED' && !addOnNotEnabled,
          })}
        >
          {workflow_task && <span>{workflow_task}.</span>}
        </div>
      </div>
    </div>
  );
};

export default Transcript;
